"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHEventHandler = void 0;
class KHEvent {
    constructor(name) {
        this.name = name;
        this.callbacks = [];
        this.callbackMap = new Map();
    }
    registerCallback(cb) {
        this.callbacks.push(cb);
    }
    registerCallbackForObject(obj, cb) {
        if (!this.callbackMap.get(obj)) {
            this.callbackMap.set(obj, []);
        }
        const arr = this.callbackMap.get(obj);
        arr.push(cb);
        this.registerCallback(cb);
    }
    unregisterCallback(cb) {
        let idx = this.callbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.callbacks.splice(idx, 1);
    }
    unregisterCallbacksForObject(obj) {
        const arr = this.callbackMap.get(obj);
        if (arr) {
            for (let cb of arr) {
                this.unregisterCallback(cb);
            }
            this.callbackMap.delete(obj);
        }
    }
    emitEvent(data) {
        this.callbacks.forEach(function (callback) {
            callback(data);
        });
    }
}
class KHEventHandler {
    constructor() {
        this.events = new Map();
    }
    ensureEvent(name) {
        let val = this.events.get(name);
        if (!val) {
            val = new KHEvent(name);
            this.events.set(name, val);
        }
        return val;
    }
    emitEvent(name, args) {
        this.ensureEvent(name).emitEvent(args);
    }
    registerCallback(name, listener) {
        this.ensureEvent(name).registerCallback(listener);
    }
    registerCallbackForObject(name, registrar, listener) {
        this.ensureEvent(name).registerCallbackForObject(registrar, listener);
    }
    unregisterCallback(name, cb) {
        this.ensureEvent(name).unregisterCallback(cb);
    }
    unregisterCallbacksForObject(name, registrar) {
        let val = this.events.get(name);
        if (val) {
            val.unregisterCallbacksForObject(registrar);
        }
    }
    unregisterAllCallbacksForObject(registrar) {
        for (let event of this.events.values()) {
            event.unregisterCallbacksForObject(registrar);
        }
    }
}
exports.KHEventHandler = KHEventHandler;
